module.exports = __webpack_public_path__ + "img/bg-rect-corner.7930b8c.png";